import React from 'react';
import PropTypes from 'prop-types';

const TableIcon = ({ scaleFactor = 1 }) => (
        <svg
            width={32 * scaleFactor}
            height={32 * scaleFactor}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="32" height="32" fill="#EAEEF0" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26 2H6C5.44772 2 5 2.44772 5 3V29C5 29.5523 5.44772 30 6 30H26C26.5523 30 27 29.5523 27 29V3C27 2.44772 26.5523 2 26 2ZM6 1C4.89543 1 4 1.89543 4 3V29C4 30.1046 4.89543 31 6 31H26C27.1046 31 28 30.1046 28 29V3C28 1.89543 27.1046 1 26 1H6Z"
                fill="#194245"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.6466 1.85359L12.3537 1.14648L16.0001 4.79293L19.6466 1.14648L20.3537 1.85359L16.5001 5.70718V26.2929L20.3536 30.1464L19.6465 30.8535L16 27.2071L12.3536 30.8535L11.6465 30.1464L15.5001 26.2928V5.70711L11.6466 1.85359Z"
                fill="#194245"
            />
        </svg>
);

TableIcon.propTypes = {
    scaleFactor: PropTypes.number,
};

export default TableIcon;
